export default "__VITE_ASSET__3983f03c__"